module.exports = __webpack_public_path__ + "static/media/music.5089be31.mp3";